/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export enum CallStatus {
  OPEN = 'OPEN',
  STARTED = 'STARTED',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  SIGNING = 'SIGNING',
  PAUSED = 'PAUSED',
  CANCELED = 'CANCELED',
  ENVELOPE_CREATION_IN_PROGRESS = 'ENVELOPE_CREATION_IN_PROGRESS',
}

export const ActiveCallStatuses = [
  CallStatus.STARTED,
  CallStatus.PAUSED,
  CallStatus.SIGNING,
  CallStatus.ENVELOPE_CREATION_IN_PROGRESS,
];
export const TerminalCallStatuses = [CallStatus.CLOSED, CallStatus.COMPLETED, CallStatus.CANCELED];
export const NonTerminalCallStatuses = Object.values(CallStatus).filter(
  // eslint-disable-next-line prettier/prettier
  (status) => !TerminalCallStatuses.includes(status),
);
